import React from 'react'

const toDrivePreview = (pdf) => {
    if (!pdf) return pdf
    if (pdf.includes('drive.google.com')) {
        return pdf.replace('/view?usp=drive_link', '/preview').replace('/view?usp=sharing', '/preview')
    }
    const match = pdf.match(/^([A-Za-z0-9_-]{20,})(\/view\?usp=.*)?$/)
    if (match) {
        return `https://drive.google.com/file/d/${match[1]}/preview`
    }
    return pdf
}

const toDriveDownload = (pdf) => {
    if (!pdf) return pdf
    if (pdf.includes('drive.google.com')) {
        const m = pdf.match(/\/d\/([A-Za-z0-9_-]+)/)
        if (m) return `https://drive.google.com/uc?export=download&id=${m[1]}`
        return pdf
    }
    const match = pdf.match(/^([A-Za-z0-9_-]{20,})(\/view\?usp=.*)?$/)
    if (match) {
        return `https://drive.google.com/uc?export=download&id=${match[1]}`
    }
    return pdf
}

const PDFV = ({ pdf }) => {
    const previewUrl = toDrivePreview(pdf)
    const downloadUrl = toDriveDownload(pdf)

    return (
        <div className="cajapdf">
            <div className="containerpdf" style={{ position: 'relative' }}>
                <a
                    href={downloadUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Descargar PDF"
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        width: '78px',
                        height: '78px',
                        background: '#000',
                        zIndex: 20,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textDecoration: 'none',
                        boxShadow: '0 0 0 2px #000'
                    }}
                >
                    <div style={{ color: '#fff', fontSize: '9px', letterSpacing: '0.06em', textAlign: 'center', lineHeight: 1.15 }}>
                        ⬇<br />DESCARGAR
                    </div>
                </a>
                <iframe
                    title="PDF viewer"
                    src={previewUrl}
                    style={{ width: '70vw', height: '80vh', border: 0, background: '#fff', display: 'block' }}
                />
            </div>
        </div>
    )
}

export default PDFV
